import * as React from 'react';
import padStart from 'lodash-es/padStart';
import { DateTimeFormats } from '../../hooks';
import { isValidDate } from '../../utils';
import { DateTimeFormatter } from '../DateTimeFormatter';

export interface TimeOnlyFormatterProps {
  time?: LocalTimeString | LocalTimeInputModel;
  utc?: boolean;
}

export const TimeOnlyFormatter: React.FC<React.PropsWithChildren<TimeOnlyFormatterProps>> = ({ time, utc }) => (
  <DateTimeFormatter date={localTimeToDate(time, utc)} format={DateTimeFormats.TIME} utc noTimeZone />
);

export type LocalTimeInputModel = { hour: number; minute: number; second?: number };

export type LocalTimeString =
  | `${number}:${number}` // HH:mm
  | `${number}:${number}:${number}` // HH:mm:ss
  | `${number}:${number} ${'am' | 'pm' | 'AM' | 'PM'}` // HH:mm am/pm/AM/PM
  | `${number}:${number}:${number} ${'am' | 'pm' | 'AM' | 'PM'}`; // HH:mm:ss am/pm/AM/PM

export const localTimeToDate = (time?: LocalTimeString | LocalTimeInputModel, utc?: boolean): Date | undefined => {
  if (!time) {
    return undefined;
  }
  let date: Date | undefined;
  if (typeof time === 'object') {
    // Hardcoded Date 2022-01-01 because LocalTime is not tied to any date, but to format it properly we need to wrap it with Date object.
    date = utc
      ? new Date(
          `2022-01-01T${padStart(`${time.hour ?? 0}`, 2, '0')}:${padStart(`${time.minute ?? 0}`, 2, '0')}:${padStart(
            `${time.second ?? 0}`,
            2,
            '0'
          )}Z`
        )
      : new Date(2022, 0, 1, time.hour, time.minute, time.second ?? 0);
  } else {
    date = utc ? new Date(`2022-01-01T${time}Z`) : new Date(`2022-01-01 ${time}`);
  }
  return isValidDate(date) ? date : undefined;
};
